import sales from './sales'
import product from './product'
import purchase from './purchase'
import finance from './finance'
import operation from './operation'
import collect from './collect'

export default {
  sales,
  product,
  purchase,
  finance,
  operation,
  collect
}



// WEBPACK FOOTER //
// ./src/api/apis/self/statistics/index.js